import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { filter, map } from '@beef/utils';
import { FieldsDecorator } from "./FieldsDecorator";
import { BuilderExtension } from "../BuilderExtension";
import { FieldsProjection } from "./FieldsProjection";

/**
 * Convert { [alias]: value}
 *   to { [alias]: { alias, value } }
 */
var standardize = function standardize(data) {
  return map(data, function (value, alias) {
    return {
      alias: alias,
      value: value,
      field: undefined
    };
  });
};

/**
 * For every Data object { [alias]: { alias, value }, ... }
 *   add a field from fields by alias,
 *   resulting in [{ alias, value, field }, ...]
 */
var assignFields = function assignFields(data) {
  var fields = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var result = standardize(data);
  fields.forEach(function (field) {
    result[field.alias] = _objectSpread(_objectSpread({}, result[field.alias]), {}, {
      alias: field.alias,
      field: field
    });
  });
  return Object.values(result);
};
export var FieldsExtension = /*#__PURE__*/function (_BuilderExtension) {
  _inherits(FieldsExtension, _BuilderExtension);
  var _super = _createSuper(FieldsExtension);
  function FieldsExtension(fields) {
    var _this;
    _classCallCheck(this, FieldsExtension);
    _this = _super.call(this);
    _this.fields = fields;
    return _this;
  }
  _createClass(FieldsExtension, [{
    key: "create",
    value: function create() {
      var _this2 = this;
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return new FieldsDecorator(assignFields(data, this.fields[params.fieldGroupId]).reduce(function (result, _ref) {
        var alias = _ref.alias,
          value = _ref.value,
          field = _ref.field;
        return _objectSpread(_objectSpread({}, result), {}, _defineProperty({}, alias, _this2.next.create(value, _objectSpread(_objectSpread({}, params), {}, {
          value: field === null || field === void 0 ? void 0 : field.default
        }))));
      }, {}), params);
    }
  }, {
    key: "createProjection",
    value: function createProjection() {
      var _this3 = this;
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return new FieldsProjection(map(data, function (item) {
        return _this3.next.createProjection(item, _objectSpread({}, params));
      }), params);
    }
  }, {
    key: "serialize",
    value: function serialize(cls) {
      var _this4 = this;
      // eslint-disable-next-line
      var result = filter(map(cls.value, function (prop) {
        return _this4.next.serialize(prop);
      }), function (value) {
        return typeof value !== 'undefined';
      });
      // return Object.keys(result).length ? result : undefined;
      return result;
    }
  }]);
  return FieldsExtension;
}(BuilderExtension);